const FOLLOW_ORGANIZER_EMAIL_CHANNEL_ID = '23';
const FOLLOW_ORGANIZER_NOTIFICATION_CHANNEL_ID = '10004';
const FOLLOW_ORGANIZER_SOURCE = 'follow-organizer-gpdr-modal';

const EXPLICIT_OPT_IN = 1;
const EXPLICIT_OPT_OUT = 2;
const EXPLICIT_CHOICES = [EXPLICIT_OPT_IN, EXPLICIT_OPT_OUT];

export function isGDPRRegime(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    // defaultRegime is injected by the airgap consent script as a top-level
    // let/const, so it is not a property of window/globalThis. We need
    // indirect eval to reach it from inside an ES module.
    // eslint-disable-next-line no-new-func
    return (
      new Function('return typeof defaultRegime !== "undefined" && defaultRegime')() === 'gdpr'
    );
  } catch {
    return false;
  }
}

interface CommSettingsPreference {
  global_preference: number;
}

interface CommSettingsResponse {
  preferences: CommSettingsPreference[];
}

export function hasChosenGDPR(response: CommSettingsResponse): boolean {
  const { preferences } = response;
  return (
    Array.isArray(preferences) &&
    preferences.length >= 2 &&
    EXPLICIT_CHOICES.includes(preferences[0].global_preference) &&
    EXPLICIT_CHOICES.includes(preferences[1].global_preference)
  );
}

function getCsrfToken(): string | undefined {
  return document.cookie
    .split('; ')
    .find((c) => c.startsWith('csrftoken='))
    ?.split('=')[1];
}

function buildCommSettingsUrl(userId: string): string {
  return `/api/v3/message/users/${userId}/comm_settings/`;
}

export async function fetchGDPRCommSettings(userId: string): Promise<CommSettingsResponse> {
  const url = `${buildCommSettingsUrl(userId)}?channel_ids=${FOLLOW_ORGANIZER_EMAIL_CHANNEL_ID},${FOLLOW_ORGANIZER_NOTIFICATION_CHANNEL_ID}&source=${FOLLOW_ORGANIZER_SOURCE}`;
  const csrfToken = getCsrfToken();

  const res = await fetch(url, {
    credentials: 'include',
    headers: {
      ...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
    },
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch GDPR comm settings: ${res.status}`);
  }

  return (await res.json()) as CommSettingsResponse;
}

export async function setFollowOrganizerStatus(userId: string, optIn: boolean): Promise<void> {
  const globalPreference = optIn ? EXPLICIT_OPT_IN : EXPLICIT_OPT_OUT;
  const csrfToken = getCsrfToken();

  await fetch(buildCommSettingsUrl(userId), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
    },
    body: JSON.stringify({
      preferences: [
        {
          channel_id: FOLLOW_ORGANIZER_EMAIL_CHANNEL_ID,
          global_preference: globalPreference,
        },
        {
          channel_id: FOLLOW_ORGANIZER_NOTIFICATION_CHANNEL_ID,
          global_preference: globalPreference,
        },
      ],
      source: FOLLOW_ORGANIZER_SOURCE,
    }),
  });
}
